module.exports = __webpack_public_path__ + "img/icon-arrow.e9fdc104.svg";